import React from "react";

export default function OptionsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6.5"
      height="26"
      viewBox="0 0 6.5 26"
    >
      <g
        id="_3_Blue_Dot"
        data-name="3 Blue Dot"
        transform="translate(6.5 26) rotate(-180)"
      >
        <g id="Group_124" data-name="Group 124" transform="translate(0 0)">
          <path
            id="Path_117"
            data-name="Path 117"
            d="M5.548.923a3.084,3.084,0,0,1,0,4.456,3.322,3.322,0,0,1-4.6,0,3.084,3.084,0,0,1,0-4.456,3.322,3.322,0,0,1,4.6,0"
            fill="#fff"
          />
          <path
            id="Path_118"
            data-name="Path 118"
            d="M5.548.923a3.084,3.084,0,0,1,0,4.456,3.322,3.322,0,0,1-4.6,0,3.084,3.084,0,0,1,0-4.456,3.322,3.322,0,0,1,4.6,0"
            transform="translate(0 9.849)"
            fill="#fff"
          />
          <path
            id="Path_119"
            data-name="Path 119"
            d="M5.548.923a3.084,3.084,0,0,1,0,4.456,3.322,3.322,0,0,1-4.6,0,3.084,3.084,0,0,1,0-4.456,3.322,3.322,0,0,1,4.6,0"
            transform="translate(0 19.697)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}
